"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Checkbox = _interopRequireDefault(require("../../Checkbox"));

var _Switch = _interopRequireDefault(require("../../Switch"));

var styles = function styles() {
  return {
    menuItem: {
      backgroundColor: '#f5f5f5',
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '20px',
      marginTop: -2
    },
    "switch": {
      alignItems: 'center',
      display: 'flex',
      marginLeft: 'auto'
    }
  };
};

var SearchOption =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(SearchOption, _React$Component);

  function SearchOption(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, SearchOption);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SearchOption).call(this, props));
    _this.state = {
      selectAllSelected: false,
      viewSelectedEnabled: false
    };
    _this.toggleSelectAll = _this.toggleSelectAll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.isIndeterminateState = _this.isIndeterminateState.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleViewSelected = _this.toggleViewSelected.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(SearchOption, [{
    key: "toggleSelectAll",
    value: function toggleSelectAll() {
      var selectAllSelected = this.state.selectAllSelected;
      var _this$props = this.props,
          selectProps = _this$props.selectProps,
          availableOptions = _this$props.availableOptions;
      var newSelectAllState = !selectAllSelected;
      var newState = {
        selectAllSelected: newSelectAllState
      };

      if (newSelectAllState === false) {
        newState.viewSelectedEnabled = false;
      }

      this.setState(newState);
      selectProps.handleSelectAll(newSelectAllState, availableOptions);
    }
  }, {
    key: "toggleViewSelected",
    value: function toggleViewSelected(e, viewSelectedEnabled) {
      var selectProps = this.props.selectProps;
      this.setState({
        selectAllSelected: viewSelectedEnabled,
        viewSelectedEnabled: viewSelectedEnabled
      });
      selectProps.handleViewSelected(viewSelectedEnabled);
    }
  }, {
    key: "isIndeterminateState",
    value: function isIndeterminateState(selectProps, availableOptions) {
      var indeterminate = false; // some available options are selected but not all available options

      var selectedCount = Array.isArray(selectProps.value) ? selectProps.value.length : 0;
      var optionCount = Array.isArray(availableOptions) ? availableOptions.length : 0;

      if (selectedCount !== optionCount && selectedCount > 0) {
        indeterminate = true;
      }

      return indeterminate;
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line react/prop-types
      var _this$props2 = this.props,
          selectProps = _this$props2.selectProps,
          availableOptions = _this$props2.availableOptions,
          classes = _this$props2.classes;
      var _this$state = this.state,
          selectAllSelected = _this$state.selectAllSelected,
          viewSelectedEnabled = _this$state.viewSelectedEnabled;
      var optionCount = Array.isArray(availableOptions) ? availableOptions.length : 0;
      var indeterminate = this.isIndeterminateState(selectProps, availableOptions);
      var someOptionsSelected = Array.isArray(selectProps.value) && selectProps.value.length;

      if (optionCount === 0) {
        return '';
      }

      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_MenuItem["default"], {
        className: classes.menuItem
      }, _react["default"].createElement(_Checkbox["default"], {
        automationid: "".concat(selectProps.automationid, "-selectAll"),
        checked: selectAllSelected,
        indeterminate: indeterminate,
        disabled: optionCount === 0,
        onChange: this.toggleSelectAll,
        className: selectProps.classes.multiSelectCheckbox
      }), "All", " (".concat(optionCount.toLocaleString(), ") "), _react["default"].createElement("span", {
        className: classes["switch"]
      }, "View Selected", _react["default"].createElement(_Switch["default"], {
        automationid: "".concat(selectProps.automationid, "-viewSelected"),
        disabled: !someOptionsSelected,
        checked: viewSelectedEnabled,
        value: "viewSelected",
        onChange: this.toggleViewSelected
      }))));
    }
  }]);
  return SearchOption;
}(_react["default"].Component);

SearchOption.propTypes = process.env.NODE_ENV !== "production" ? {
  availableOptions: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  selectProps: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array])
} : {};

var _default = (0, _styles.withStyles)(styles)(SearchOption);

exports["default"] = _default;